import { toast } from "react-toastify";
import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
const isMobile = window.innerWidth <= 600;

const isValuePresent = (value) => {
  return (
    value !== null &&
    value !== undefined &&
    value !== "" &&
    // value !== false &&
    !(Array.isArray(value) && value.length === 0) &&
    !(typeof value === "object" && Object.keys(value).length === 0)
  );
};

const isAudioFile = (url) => {
  return /\.(mp3|wav|ogg|aac|flac|m4a|mp4)$/i.test(url);
};

const handleToast = (error) => {
  if (error === undefined) {
    toast.error(error?.message || "Bad request.", {
      position: isMobile ? "top-left" : "top-center",
      color: "rgb(231, 24, 24)",
      style: {
        width: isMobile ? "300px" : "400px",
        textWrap: isMobile && "wrap",
      },
    });
  }
  if (error?.message instanceof Array) {
    Object.values(error.message).forEach((msg) =>
      toast.error(msg || "Bad request", {
        position: "top-center",
        color: "rgb(231, 24, 24)",
        style: {
          width: "500px",
        },
      })
    );
  } else {
    toast.error(error?.message || "Bad request.", {
      position: isMobile ? "top-left" : "top-center",
      color: "rgb(231, 24, 24)",
      style: {
        width: isMobile ? "300px" : "400px",
        textWrap: isMobile && "wrap",
      },
    });
  }
};

const isImageURL = (url) => {
  return /\.(jpg|jpeg|png|gif|webp|avif|svg)$/i.test(url);
};

const decryptData = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  } catch (err) {
    console.error("Decryption failed:", err);
    return null;
  }
};

const decryptObject = (encrypted) => {
  const key = CryptoJS.SHA256(SECRET_KEY);
  const iv = CryptoJS.enc.Base64.parse(encrypted.iv);
  const decrypted = CryptoJS.AES.decrypt(encrypted.content, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedText);
};

const scrollUp = () => window.scrollTo(0, 0);

const scrollDown = () =>
  window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });

const reducer = (state, action) => {
  const inputs = Object.keys(state);

  if (inputs.includes(action.type) || action?.force) {
    // if(action.type === "location_type") {
    //   state.location_id = '';
    // }
    return { ...state, [action.type]: action.payload };
  }

  if (action.type === "reset") {
    const resetState = inputs.reduce((obj, key) => {
      obj[key] = "";
      return obj;
    }, {});

    return resetState;
  }

  return state;
};

function decodeJWT(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const isValidDecimalInput = (value) => {
  if (value === "") return true;
  if (typeof value !== "string") return false;

  const cleaned = value.replace(/[^\d.]/g, ""); // Remove all except digits and dot
  const numericValue = parseFloat(cleaned);

  // Reject if:
  // - Not a number
  // - Less than or equal to 0
  // - All digits are 0 (e.g. 000000, 000.00)
  if (
    isNaN(numericValue) ||
    numericValue <= 0 ||
    /^0+(\.0+)?$/.test(cleaned) // Matches 000000 or 000.000
  ) {
    return false;
  }

  return true;
};

const getUserInitialPath = (user) => {
  if (!user || !user.permissions || user.permissions.length === 0) {
    return "/";
  } else if (user.permissions[0] === "CONSULTANT_RECORDINGS") {
    return "/admin/consultant_recording";
  } else if (user.permissions[0] === "BANK_ACCOUNTS") {
    return "/admin/bank_account";
  } else {
    return `/admin/${user.permissions[0].toLowerCase()}`;
  }
};

export {
  isValuePresent,
  handleToast,
  isAudioFile,
  isImageURL,
  decryptData,
  decryptObject,
  scrollUp,
  scrollDown,
  reducer,
  decodeJWT,
  isValidEmail,
  isValidDecimalInput,
  getUserInitialPath,
};
